import Vue from 'vue';
import { MUTATION } from './CONSTANTS';

export default {
  [MUTATION.SET_DATA](state, data) {
    Vue.set(state, 'data', data);
  },
  [MUTATION.SET_TOKEN](state, token) {
    Vue.set(state, 'token', token);
  },
};
